import $ from 'jquery';

$(function () {
  $('.js-solicitation-area').on(
    'click',
    '.js-edit-feedback-button',
    function () {
      $(this)
        .closest('.js-solicitation-block')
        .find('.js-comments-overlay')
        .removeClass('hidden');
    },
  );

  $('.js-solicitation-area').on(
    'click',
    '.js-edit-recovery-button',
    function () {
      $(this)
        .closest('.js-solicitation-block')
        .find('.js-recovery-comments-overlay')
        .removeClass('hidden');
    },
  );

  var errorFunction = function ($solicitation) {
    return function () {
      $solicitation.find('.js-feedback-edit-error').removeClass('hidden');
      $solicitation
        .find('.js-solicitation-comment-buttons, .js-edit-feedback-button-area')
        .addClass('hidden');
    };
  };

  $('.js-solicitation-area').on(
    'click',
    '.js-comfirm-remove-comments',
    function () {
      var url = this.dataset.url;
      var $solicitation = $(this).closest('.js-solicitation-block');
      this.disabled = true;
      this.innerText = this.dataset.disabledText;
      $solicitation
        .find('.js-close-overlay, .js-comfirm-archive')
        .addClass('hidden');
      $.ajax({
        type: 'PUT',
        url: url,
        success: function () {
          var toHide =
            '.js-solicitation-comment-buttons, .js-comments, .js-edit-feedback-button-area';
          var toShow =
            '.js-comment-removed-area, .js-comment-removed-confirmation';
          $solicitation.find(toHide).addClass('hidden');
          $solicitation.find(toShow).removeClass('hidden');
          window.setTimeout(function () {
            $solicitation.find('.js-comments-overlay').fadeOut(1000);
          }, 1500);
          window.setTimeout(function () {
            $solicitation.find('.js-recovery-comments-overlay').fadeOut(1000);
          }, 1500);

        },
        error: errorFunction($solicitation),
      });
    },
  );

  $('.js-solicitation-area').on('click', '.js-comfirm-archive', function () {
    var url = this.dataset.url;
    var $solicitation = $(this).closest('.js-solicitation-block');
    this.disabled = true;
    this.innerText = this.dataset.disabledText;
    $solicitation
      .find('.js-close-overlay, .js-comfirm-remove-comments')
      .addClass('hidden');
    $.ajax({
      type: 'PUT',
      url: url,
      success: function () {
        var toHide =
          '.js-solicitation-comment-buttons, .js-edit-feedback-button-area';
        var toShow = '.js-data-removed-confirmation';
        $solicitation.find(toHide).addClass('hidden');
        $solicitation.find(toShow).removeClass('hidden');
        window.setTimeout(function () {
          $solicitation.fadeOut(1000);
        }, 1500);
      },
      error: errorFunction($solicitation),
    });
  });

  $('.js-solicitation-area').on('click', '.js-close-overlay', function () {
    $(this)
      .closest('.js-solicitation-block')
      .find('.js-comments-overlay')
      .addClass('hidden');
  });
  $('.js-solicitation-area').on('click', '.js-close-overlay', function () {
    $(this)
      .closest('.js-solicitation-block')
      .find('.js-recovery-comments-overlay')
      .addClass('hidden');
  });
});
